import { Grid, Card, CardHeader, CardContent, Button, Typography } from '@mui/material';
import { useState } from 'react';

import { useFormContext } from 'react-hook-form';
import { contactApiKeyStore } from '../../../../api/contact-api-key-store';
import { SiTrackGrid } from '../../../../components/si-track-grid/si-track-grid';
import { Contact } from '../../../../models/contact';
import { ContactsDialogWithGridSelect } from '../../../contacts/contact-diallog-with-grid-selection';
import { columns } from './grid-columns';
import { UserPermissionName } from '../../../../models/user-permission-name';

interface ContactsFormProps {
  name: string;
  label: string;
}

export const ContactsForm = ({ name, label }: ContactsFormProps) => {
  const [openDialog, setOpenDialog] = useState(false);
  const { setValue, getValues } = useFormContext();
  const [valueForTab, setValueForTab] = useState('view');
  const [editItem, setEditItem] = useState<Contact>();

  const handleOpenAddContactForm = () => {
    setOpenDialog(true);
  };

  const handleEdit = (value: Contact) => {
    setEditItem(value);
    setValueForTab('edit');
    handleOpenAddContactForm();
  };

  const handleCloseAddContactForm = (contacts: Contact[]) => {
    setOpenDialog(false);
    setValue(name, contacts);
    setEditItem(undefined);
  };

  return (
    <Card elevation={0}>
      <CardHeader
        className="subHead"
        title={
          <Typography variant="h3" color="textPrimary">
            CONTACTS
          </Typography>
        }
        action={
          <Button
            className="btnLink"
            variant="text"
            sx={{ p: 0, m: 0, mr: 1 }}
            onClick={() => handleOpenAddContactForm()}
          >
            Add Contacts
          </Button>
        }
      ></CardHeader>
      <CardContent className="formContainer">
        <Grid container>
          <Grid item lg={12} sm={12} xl={12} xs={12}>
            {/* <FormAutoCompleteMultiSelectDynamic
              name={name}
              label={label}
              dataItems={getValues(name)}
              getQueryKeyConfig={() => contactApiKeyStore.getCustomerContacts(getValues('customerID'))}
              optionsLabelKey="contactsFirstName"
              optionsValueKey="contactsID"
            /> */}
            <SiTrackGrid
              fileTitle='municipality_contact'
              dataItems={getValues(name)}
              dataItemKey="contactsID"
              columns={columns}
              actionPermissions={{
                export: UserPermissionName.DOWNLOAD_GRID
              }}
            // onEdit={handleEdit}
            // deleteMutationConfig={(item) => contactApiKeyStore.deleteContact(item.contactsID)}
            />
          </Grid>
        </Grid>
        {openDialog && (
          <ContactsDialogWithGridSelect
            open={openDialog}
            onClose={handleCloseAddContactForm}
            contacts={getValues(name)}
            customerID={getValues('customer.customerID')}
            setValue={setValueForTab}
            value={valueForTab}
            editItem={editItem}
            setEditItem={setEditItem}
            watchKeys={['customer.customerID']}
            getQueryKeyConfig={() => contactApiKeyStore.getMunicipalityContacts(getValues('municipalityID'))}
            page="municipality"
          />
        )}
      </CardContent>
    </Card>
  );
};
